import {
  LocalDate,
  LocalDateTime,
  LocalTime,
  nativeJs,
  TemporalAccessor,
  ZonedDateTime,
} from '@js-joda/core'
import { format } from 'date-fns'
import { US_DATE_FORMAT } from '@migrate/utils/date/constants'
import i18next from 'i18next'
import LocalDateConverter from '@migrate/utils/date/LocalDateConverter'

export default class NativeDateConverter {
  private readonly value: Date

  constructor(value: Date) {
    this.value = value
  }

  private toTemporalAccessor(): TemporalAccessor {
    return nativeJs(this.value)
  }

  public toLocalDate(): LocalDate {
    return LocalDate.from(this.toTemporalAccessor())
  }

  public toLocalDateTime(): LocalDateTime {
    return LocalDateTime.from(this.toTemporalAccessor())
  }

  public toLocalTime(): LocalTime {
    return LocalTime.from(this.toTemporalAccessor())
  }

  public toZonedDateTime(): ZonedDateTime {
    return ZonedDateTime.from(this.toTemporalAccessor())
  }

  public toUsDateString(): string {
    return format(this.value, US_DATE_FORMAT)
  }

  public toLocalizedDateString(locale: string = i18next.language) {
    return new LocalDateConverter(this.toLocalDate()).toLocalizedString(locale)
  }
}
